// Core functionality of redux state is tied to these methods and param reassignment.
// Since Redux is basically legacy code at this point we are grandfathering in these files. The rule will be enforced for any new code committed.
/* eslint-disable no-param-reassign */
import SearchParameterInteraction from 'app/models/searchParameterInteraction';
import SearchParameterAvailabilityInteraction from 'app/models/searchParameterAvailabilityInteraction';
import SearchScopes from 'app/models/searchScopes';
import setDefaults from 'app/support/searchParameterDefaults';

export const getStateUpdatesForNewSearchParameters = (
  galleryState,
  updatedSearchParameters
) => {
  // A cookied param for which we need defaults might have been removed
  // - i.e. 'license' - so we need to set defaults again.
  const stateUpdates = {
    searchParameters: setDefaults(
      updatedSearchParameters,
      galleryState.availableSearchParameters
    ),
  };

  new SearchScopes(galleryState).applyStateUpdates(stateUpdates);
  new SearchParameterInteraction(galleryState).applyStateUpdates(stateUpdates);
  new SearchParameterAvailabilityInteraction(galleryState).applyStateUpdates(
    stateUpdates
  );

  return stateUpdates;
};
